import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  readonly key = 'token';

  get(): string {
    return localStorage.getItem(this.key);
  }

  set(newToken: string): void {
    localStorage.setItem(this.key, newToken);
  }

  remove(): void {
    return localStorage.removeItem(this.key);
  }
}
